// @ts-nocheck
import * as Types from '../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type CommentStreamCountDetailFragment = { __typename?: 'CommentStream', id: string, commentCount: number, unreadCount: number };

export const CommentStreamCountDetailFragmentDoc = gql`
    fragment CommentStreamCountDetail on CommentStream {
  id
  commentCount
  unreadCount
}
    `;